/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import { createContext, useContext } from 'react';
import { NodesData } from './Interfaces'
import { useParams } from 'react-router-dom';
export const NodesGlobalContext = createContext<NodesData>({})
export const useNodes = () => useContext(NodesGlobalContext)
export const useCurrentEnvironmentNodes = () => {
    const { env } = useParams<{ env: string }>();
    const nodes = useNodes();
    return nodes[env];
}